/**
 * @file 更多列表
 * @author FengGuang(fengguang01@baidu.com)
 */

import React from 'react';

import TextCardGroup from '../../../../components/text-card/TextCardGroup';
import moreListData from './moreListData';


const MoreList: React.FC = () => {
    return (
        <TextCardGroup
            className="paddle-more-list"
            option={moreListData}
        />
    );
};

export default MoreList;
